module.exports = __webpack_public_path__ + "img/download-lp.4a108529.svg";